import { Modal, Button } from "components/ui/BootstrapCompat";
import { Formik, Form } from "formik";
import CustomInput from "../CustomInput";
import { errorAdd, successAdd } from "helpers/sweetalert";
import { FaSave } from "react-icons/fa";
import { FaUser } from "react-icons/fa6";
import { useQueryClient } from "react-query";
import { userUpdateOne } from "services/user.service";
import useLocalStorage from "helpers/useLocalStorage";

interface Props {
  open: boolean;
  onClose: () => void;
  data: any;
  businessId: string;
  callback?: (value: any) => void;
}

export default function PopUpEditUser({ open, onClose, data, businessId, callback }: Props) {
  const queryClient = useQueryClient();
  const [token] = useLocalStorage("token", "");

  const onSubmit = async (values: any) => {
    try {
      const result = await userUpdateOne({ _id: data?._id, ...values }, token, businessId);
      await queryClient.invalidateQueries(["user-list"]);
      callback?.(result);
      successAdd("ແກ້ໄຂຂໍ້ມູນສຳເລັດ");
      onClose();
    } catch (error: any) {
      errorAdd(error?.response?.data?.message || "ເກີດຂໍ້ຜິດພາດ");
    }
  };

  return (
    <Modal show={open} onHide={onClose} keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="flex gap-2 items-center">
            <FaUser />
            ແກ້ໄຂຜູ້ໃຊ້
          </div>
        </Modal.Title>
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={{
          name: data?.name || "",
          email: data?.email || "",
          phone: data?.phone || "",
          role: data?.role || "user",
          status: data?.status || "active",
        }}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <div className="flex flex-col gap-[10px]">
                <CustomInput
                  require
                  label="ຊື່ຜູ້ໃຊ້"
                  name="name"
                  type="text"
                  placeholder="-- ຊື່ຜູ້ໃຊ້ --"
                />
                <CustomInput
                  label="ອີເມວ"
                  name="email"
                  type="email"
                  placeholder="-- ອີເມວ --"
                />
                <CustomInput
                  label="ເບີໂທ"
                  name="phone"
                  type="text"
                  placeholder="-- ເບີໂທ --"
                />
                <CustomInput
                  require
                  as="select"
                  label="ສິດ"
                  name="role"
                  onChange={(e: any) => setFieldValue("role", e.target.value)}
                >
                  <option value="user">ຜູ້ໃຊ້ທົ່ວໄປ</option>
                  <option value="admin">ຜູ້ດູແລລະບົບ</option>
                </CustomInput>
                <CustomInput
                  require
                  as="select"
                  label="ສະຖານະ"
                  name="status"
                  onChange={(e: any) => setFieldValue("status", e.target.value)}
                >
                  <option value="active">ເຄື່ອນໄຫວ</option>
                  <option value="inactive">ບໍ່ເຄື່ອນໄຫວ</option>
                </CustomInput>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                type="submit"
                className="w-full h-[54px] flex items-center gap-2 justify-center text-lg"
              >
                <FaSave className="w-[24px] h-[24px]" />
                ບັນທຶກການແກ້ໄຂ
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
